import { cn } from '@distribute/frontend/utils';

import { Select, SelectContent, SelectTrigger } from './SelectV2';
import { SelectItem } from './SelectV2';
import { IconMap } from '../../sprite';
import { Icon, SpriteGlyph } from '../Icon';

export type SortType = 'lastCreated' | 'name';

type SortItem = {
  glyph: SpriteGlyph;
  label: string;
};
export const DEFAULT_SORT_ITEMS: Record<SortType, SortItem> = {
  lastCreated: { glyph: IconMap.Calendar, label: 'Last created' },
  name: { glyph: IconMap.Sorting, label: 'Name' },
} as const;

type Props<T extends string> = {
  value: T;
  onChange: (value: T) => void;
  items?: Record<T, SortItem>;
  className?: string;
  classNameContent?: string;
};

export const SelectSort = <T extends string = SortType>({
  value,
  onChange,
  items = DEFAULT_SORT_ITEMS as unknown as Record<T, SortItem>,
  className,
  classNameContent,
}: Props<T>) => {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        className={cn('w-45', className)}
        classNameValue="flex items-center gap-x-1"
      >
        <Icon glyph={items[value].glyph} width={20} className="flex-shrink-0" />
        <span className="truncate">{items[value].label}</span>
      </SelectTrigger>
      <SelectContent
        side="bottom"
        align="end"
        sideOffset={4}
        showIcon
        className={classNameContent}
      >
        {Object.keys(items).map((key) => (
          <SelectItem
            value={key}
            key={key}
            classNameValue="flex items-center gap-x-2"
          >
            <Icon
              glyph={items[key as T].glyph}
              width={16}
              className="flex-shrink-0"
            />
            <span className="truncate">{items[key as T].label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
